export default __webpack_public_path__ + "static/media/edo-logo-250.1846ef21.png";